
import { defineComponent } from 'vue';
import { mapState } from 'vuex';

const partPath = [
  '/part-result',
  '/part',
  '/part-detail',
  '/diagram',
  '/catalogue',
  '/spare-part'
];

const productPath = ['/products', '/products-inquiry'];

const orderPath = [
  '/order',
  '/vehicle-order-detail',
  '/vehicle-logistics-info',
  '/part-logistics-info',
  '/vehicle-logistics-detail',
  '/part-logistics-detail',
  '/part-order-detail'
];

export default defineComponent({
  name: 'Nav',
  props: {
    msg: String
  },
  computed: {
    ...mapState(['userInfo'])
  },
  data() {
    return {
      isRelatedToPart: false,
      isRelatedToProd: false,
      isRelatedToOrder: false
    };
  },
  watch: {
    '$route.path': {
      handler(newVal) {
        // scroll to top
        // if (newVal.toUpperCase().indexOf('/home'.toUpperCase()) >= 0) {
        //   document.body.scrollTop = document.documentElement.scrollTop = 100;
        // } else {
        //   window.scrollTo(0, 0);
        // }
        window.scrollTo(0, 0);

        if (
          orderPath.some(
            p => newVal.toUpperCase().indexOf(p.toUpperCase()) >= 0
          )
        ) {
          this.isRelatedToOrder = true;
          this.isRelatedToPart = false;
          this.isRelatedToProd = false;
          return;
        } else {
          this.isRelatedToOrder = false;
        }

        if (
          productPath.some(
            p => newVal.toUpperCase().indexOf(p.toUpperCase()) >= 0
          )
        ) {
          this.isRelatedToProd = true;
          this.isRelatedToOrder = false;
          this.isRelatedToPart = false;
          return;
        } else {
          this.isRelatedToProd = false;
        }

        if (
          partPath.some(p => newVal.toUpperCase().indexOf(p.toUpperCase()) >= 0)
        ) {
          this.isRelatedToPart = true;
          this.isRelatedToOrder = false;
          this.isRelatedToProd = false;
          return;
        } else {
          this.isRelatedToPart = false;
        }
      },
      immediate: true
    }
  }
});
